import { CapaServiceType } from '@generated/graphql';
import getScopes from '@utils/getScopes';
import { useEffect } from 'react';
import { useState } from 'react';

const useServiceTab = (
  callback?: () => void
): [CapaServiceType, (service: CapaServiceType) => void] => {
  const { scopes } = getScopes();

  const [service, setService] = useState<CapaServiceType>(() => {
    if (scopes.length > 0) {
      return scopes[0];
    } else {
      return CapaServiceType.Quotation;
    }
  });

  const onChange = (service: CapaServiceType) => {
    if (callback) {
      callback();
    }

    setService(service);
  };

  useEffect(() => {
    if (scopes.length > 1) return;

    if (scopes.length === 1) {
      return setService(scopes[0]);
    }
  }, [scopes]);

  return [service, onChange];
};

export default useServiceTab;
